import React from 'react';
import './NewPostsBanner.css';

export default function NewPostsBanner({ count, onClick }) {
  const n = Number(count) || 0;
  if (n <= 0) return null;

  return (
    <div className="new-posts-banner-wrap">
      <button type="button" className="new-posts-banner" onClick={onClick}>
        {n === 1 ? '1 new post' : `${n} new posts`}
      </button>
    </div>
  );
}
